import { combineReducers } from "redux"
import turnero from './turnero'

const rootReducer = combineReducers({
    turnero: turnero
})

export default rootReducer;